export const NOTIFICATION_ENTRY_DIVIDER_TYPE = 'DIVIDER';

export const NOTIFICATION_GROUP_TYPES = {
    ELEMENT: 'ELEMENT',
    TEMPLATE: 'TEMPLATE',
    GENERAL: 'GENERAL',
};
